import { forTemplate } from 'app/common/lib/util/i18n';
import { AlertContainer } from 'app/gamma/src/components/alert';
import {
  ReactionErrorName,
  ReactionLimits,
  ReactionsAlertArea,
} from 'app/gamma/src/modules/state/models/reactions';
import React from 'react';

const format = forTemplate('reactions');

export const ReactionAlerts: React.FunctionComponent = () => {
  return (
    <>
      <AlertContainer
        displayType="error"
        name={ReactionErrorName.ACTION_TOO_MANY_TOTAL_REACTIONS}
        area={ReactionsAlertArea}
        msTimeout={3000}
      >
        {format('total-reaction-limit-exceeded', {
          heart: '❤',
          number: ReactionLimits.perAction.toString(),
        })}
      </AlertContainer>
      <AlertContainer
        displayType="error"
        name={ReactionErrorName.ACTION_TOO_MANY_UNIQUE_REACTIONS}
        area={ReactionsAlertArea}
        msTimeout={3000}
      >
        {format('unique-reaction-limit-exceeded', {
          heart: '❤',
          number: ReactionLimits.uniquePerAction.toString(),
        })}
      </AlertContainer>
    </>
  );
};
